/**
 * Set button to a loading or finished state
 *
 * @since 1.0.0
 */
export default (currentScrollHeight, previousScrollHeight) => {
  const windowHeight = window.innerHeight;
  const header = document.querySelector('.js-header')
  const menuButton = document.querySelector('.js-nav-btn')
  const menuButtonContainer = document.querySelector('.js-nav-btn-container')
  const menu = document.querySelector('.js-nav')

  if(currentScrollHeight > windowHeight && currentScrollHeight > previousScrollHeight && header.classList.contains('c-header__link--max')){
        minimizeMenu(header, menuButton, menuButtonContainer, menu);
  }
  else if(currentScrollHeight < previousScrollHeight && header.classList.contains('c-header__link--min')){
      maximizeMenu(header, menuButton, menuButtonContainer, menu);
  }
}


export function minimizeMenu(header, menuButton, menuButtonContainer, menu) {
  header.classList.add('c-header__link--min');
  header.classList.remove('c-header__link--max');
  menuButton.classList.add('c-nav__button--min');
  menuButton.classList.remove('c-nav__button--max');
  menuButtonContainer.classList.add('c-nav__button-container--min');
  menuButtonContainer.classList.remove('c-nav__button-container--max');

  menu.classList.add('c-nav--min');
  menu.classList.remove('c-nav--max');
}
export function maximizeMenu(header, menuButton, menuButtonContainer, menu) {
  header.classList.add('c-header__link--max');
  header.classList.remove('c-header__link--min');
  menuButton.classList.add('c-nav__button--max');
  menuButton.classList.remove('c-nav__button--min');
  menuButtonContainer.classList.add('c-nav__button-container--max');
  menuButtonContainer.classList.remove('c-nav__button-container--min');

  menu.classList.add('c-nav--max');
  menu.classList.remove('c-nav--min');
}


// WEBPACK FOOTER //
// ./src/js/modules/onScrollEffects/ScrollHeader.js